import React, { Component } from "react";
import {
  PageHeader, Row, Col, Card, Statistic, Spin, Empty, message,
  Table, Tag, Select, Space, Tooltip, Tabs,
} from "antd";
import {
  FunnelPlotOutlined, DollarOutlined,
  TeamOutlined, RiseOutlined, FileExcelOutlined, FilePdfOutlined,
} from "@ant-design/icons";
import {
  Form, FormItem, ButtonItem, SelectItem, RangePickerItem,
} from "../../../../Components/Items";
import { HeaderEmpresaCard } from "../../../../Components/PdfComponents/HeaderEmpresaCard";
import { ResponsiveBar } from "@nivo/bar";
import axios from "axios";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as XLSX from "xlsx";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import moment from "moment";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Option } = Select;
const { TabPane } = Tabs;

const fmt = (val) =>
  `$${(val ?? 0).toLocaleString("es-MX", { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;

const CARD_STYLE = { borderRadius: 10, overflow: "hidden" };

const COLORES_PDF = [
  "#4e79a7","#f28e2b","#e15759","#76b7b2",
  "#59a14f","#edc948","#b07aa1","#ff9da7","#9c755f","#bab0ac",
];

const buildBarras = (datos, getVal, getLabel, fmtFn = String) => {
  const maxV = Math.max(...datos.map(getVal), 1);
  const W = 190, H = 11, G = 5;
  return {
    columns: [
      {
        width: W,
        canvas: datos.map((d, i) => ({
          type: "rect", x: 0, y: i * (H + G),
          w: Math.max(2, Math.round((getVal(d) / maxV) * W)),
          h: H, color: d.color || COLORES_PDF[i % COLORES_PDF.length], r: 2,
        })),
      },
      {
        width: "*",
        margin: [8, 0, 0, 0],
        stack: datos.map((d) => ({
          text: `${getLabel(d)}  ${fmtFn(getVal(d))}`,
          style: "textoTabla", color: "#444", margin: [0, 2, 0, G - 2],
        })),
      },
    ],
    margin: [0, 4, 0, 10],
  };
};

const PDF_STYLES = {
  header:               { fontSize: 9, bold: true },
  subheader:            { fontSize: 8, bold: true },
  tableExample:         { margin: [0, 5, 0, 5] },
  tableHeader:          { bold: true, fontSize: 12, color: "black", alignment: "center" },
  tableHeaderIzquierda: { bold: true, fontSize: 18, color: "black" },
  textoChico:           { fontSize: 8 },
  tituloTabla:          { fontSize: 7, bold: true, fillColor: "#cccccc", alignment: "center" },
  textoTabla:           { fontSize: 7 },
  totalChico:           { fontSize: 7, bold: true, fillColor: "#cccccc", alignment: "right" },
};

class ReporteEmbudo extends Component {
  formRef = React.createRef();

  state = {
    loading:    false,
    datos:      [],
    embudos:    [],
    periodoStr: "",
  };

  componentDidMount() {
    this.cargarEmbudos();
  }

  cargarEmbudos = async () => {
    const defaultValues = { periodo: [moment().startOf("year"), moment()] };
    try {
      const res = await axios.post(
        "embudos/selectEmbudosItem",
        { empresaId: this.props.empresaId, query: "" },
        { headers: this.props.headersToken },
      );
      if (res.data.success === 2) {
        this.setState({ embudos: res.data.embudos ?? [] }, () => {
          this.onFinish(defaultValues);
        });
      } else {
        this.onFinish(defaultValues);
      }
    } catch {
      this.onFinish(defaultValues);
    }
  };

  onFinish = (values) => {
    const { periodo, embudoId } = values;
    const periodoStr = periodo
      ? `${periodo[0].format("DD/MM/YYYY")} - ${periodo[1].format("DD/MM/YYYY")}`
      : "Histórico completo";
    this.setState({ periodoStr });
    this.cargarDatos({
      fechaInicio: periodo?.[0]?.toISOString() ?? null,
      fechaFin:    periodo?.[1]?.toISOString() ?? null,
      embudoId:    embudoId ?? null,
    });
  };

  cargarDatos = async ({ fechaInicio, fechaFin, embudoId } = {}) => {
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "reportesCRM/pipelineReporte",
        { empresaId: this.props.empresaId, fechaInicio, fechaFin, embudoId },
        { headers: this.props.headersToken },
      );
      if (res.data.success === 2) {
        const ordenado = [...res.data.datos].sort((a, b) => b.cantidadLeads - a.cantidadLeads);
        this.setState({ datos: ordenado });
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({ loading: false });
    }
  };

  calcularKPIs() {
    const { datos } = this.state;
    if (!datos.length) return { totalLeads: 0, totalValor: 0, etapaTop: "—", tasaAvance: "—" };
    const totalLeads = datos.reduce((s, d) => s + d.cantidadLeads, 0);
    const totalValor = datos.reduce((s, d) => s + d.totalValor, 0);
    const etapaTop   = datos[0]?.nombre ?? "—";
    let tasaAvance   = "—";
    if (datos.length >= 2 && datos[0].cantidadLeads > 0)
      tasaAvance = `${((datos[datos.length - 1].cantidadLeads / datos[0].cantidadLeads) * 100).toFixed(1)}%`;
    return { totalLeads, totalValor, etapaTop, tasaAvance };
  }

  descargarExcel = () => {
    const { datos } = this.state;
    const totalLeads = datos.reduce((s, d) => s + d.cantidadLeads, 0);
    const filas = datos.map((d) => ({
      Etapa:           d.nombre,
      Embudo:          d.nombreEmbudo,
      "Leads Activos": d.cantidadLeads,
      "Valor Total":   d.totalValor,
      "% del Total":   totalLeads > 0 ? `${((d.cantidadLeads / totalLeads) * 100).toFixed(1)}%` : "—",
    }));
    const ws = XLSX.utils.json_to_sheet(filas);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Oportunidades en Proceso");
    XLSX.writeFile(wb, `Oportunidades_en_Proceso_${new Date().toLocaleDateString("es-MX").replace(/\//g, "-")}.xlsx`);
  };

  descargarPdf = async () => {
    this.setState({ loading: true });
    try {
      const { datos, periodoStr } = this.state;
      const totalLeads = datos.reduce((s, d) => s + d.cantidadLeads, 0);
      const totalValor = datos.reduce((s, d) => s + d.totalValor, 0);

      const resEmpresa = await axios.post(
        "reportesCRM/datosEmpresaPdf",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      );
      const empresa = resEmpresa.data.success === 2 ? resEmpresa.data.empresa : {};

      const grafica = datos.length
        ? buildBarras(datos, (d) => d.cantidadLeads, (d) => d.nombre)
        : null;

      const cuerpoTabla = datos.map((d) => [
        { text: d.nombre,       style: "textoTabla" },
        { text: d.nombreEmbudo, style: "textoTabla" },
        { text: d.cantidadLeads, style: "textoTabla", alignment: "right" },
        { text: fmt(d.totalValor), style: "textoTabla", alignment: "right" },
        { text: totalLeads > 0 ? `${((d.cantidadLeads / totalLeads) * 100).toFixed(1)}%` : "—", style: "textoTabla", alignment: "right" },
      ]);
      cuerpoTabla.push([
        { text: "TOTAL", style: "totalChico", colSpan: 2 }, {},
        { text: totalLeads, style: "totalChico" },
        { text: fmt(totalValor), style: "totalChico" },
        { text: "100%", style: "totalChico" },
      ]);

      const terceraColumna = {
        border: [false, false, false, false],
        table: {
          widths: ["100%"],
          body: [
            [{ text: "Oportunidades en Proceso CRM", style: "tableHeader", alignment: "center" }],
            [{ text: periodoStr,                     style: "textoChico",  alignment: "center" }],
            [{ text: "Fecha de Impresión:",           style: "subheader",   alignment: "center" }],
            [{ text: new Date().toLocaleDateString("es-MX"), style: "textoChico", alignment: "center" }],
          ],
        },
        layout: "noBorders",
      };

      const dd = {
        pageSize:    "LETTER",
        pageMargins: [20, 20, 20, 40],
        content: [
          {
            style: "tableExample",
            table: {
              widths: ["15%", "55%", "30%"],
              body: [[...HeaderEmpresaCard(empresa, false, false, terceraColumna)]],
            },
          },
          { text: "Oportunidades en Proceso", style: "tableHeaderIzquierda", margin: [0, 6, 0, 8] },
          ...(grafica ? [
            { text: "Distribución de Leads por Etapa", style: "subheader", margin: [0, 0, 0, 4] },
            grafica,
          ] : []),
          { text: "Detalle por Etapa", style: "subheader", margin: [0, 4, 0, 4] },
          {
            style: "tableExample",
            table: {
              headerRows: 1,
              widths: ["*", "*", "auto", "auto", "auto"],
              body: [
                [
                  { text: "Etapa",       style: "tituloTabla" },
                  { text: "Embudo",      style: "tituloTabla" },
                  { text: "Leads",       style: "tituloTabla" },
                  { text: "Valor Total", style: "tituloTabla" },
                  { text: "% del Total", style: "tituloTabla" },
                ],
                ...cuerpoTabla,
              ],
            },
            layout: {
              fillColor:  (i) => i % 2 === 0 && i !== 0 ? "#e8e8e8" : "#ffffff",
              hLineColor: () => "#adaaaa",
              vLineColor: () => "#adaaaa",
            },
          },
        ],
        images: { logo: empresa?.logo?.base64Completa ?? "" },
        styles: PDF_STYLES,
      };
      pdfMake.createPdf(dd).download(`Oportunidades_en_Proceso_${new Date().toLocaleDateString("es-MX").replace(/\//g, "-")}.pdf`);
    } catch (e) {
      message.error("Hubo un error al generar el PDF.");
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { loading, datos, embudos } = this.state;
    const { history } = this.props;
    const { totalLeads, totalValor, etapaTop, tasaAvance } = this.calcularKPIs();
    const totalLeadsGlobal = datos.reduce((s, d) => s + d.cantidadLeads, 0);

    const columns = [
      { title: "Etapa",       dataIndex: "nombre",        render: (n, r) => <Tag color={r.color}>{n}</Tag> },
      { title: "Embudo",      dataIndex: "nombreEmbudo" },
      { title: "Leads",       dataIndex: "cantidadLeads",  align: "center", render: (v) => <strong>{v}</strong> },
      { title: "Valor Total", dataIndex: "totalValor",     align: "right",  render: (v) => fmt(v) },
      {
        title: "% del Total", align: "right",
        render: (_, r) => totalLeadsGlobal > 0 ? `${((r.cantidadLeads / totalLeadsGlobal) * 100).toFixed(1)}%` : "—",
      },
    ];

    return (
      <Form
        ref={this.formRef}
        onFinish={this.onFinish}
        initialValues={{ periodo: [moment().startOf("year"), moment()] }}
      >
        <PageHeader
          title={<span><FunnelPlotOutlined style={{ marginRight: 8, color: "#1890ff" }} />Oportunidades en Proceso</span>}
          subTitle="Leads activos por etapa del proceso de cierre"
          onBack={() => history.push("/panel/crmReportes")}
          style={{ border: "1px solid rgb(235,237,240)", backgroundColor: "white", marginBottom: 15 }}
          extra={
            <Space wrap>
              {datos.length > 0 && (
                <Tooltip title="Descargar Excel">
                  <span>
                    <ButtonItem verde icon={<FileExcelOutlined />} onClick={this.descargarExcel} />
                  </span>
                </Tooltip>
              )}
              {datos.length > 0 && (
                <Tooltip title="Descargar PDF">
                  <span>
                    <ButtonItem rojo icon={<FilePdfOutlined />} onClick={this.descargarPdf} loading={loading} />
                  </span>
                </Tooltip>
              )}
              <ButtonItem azul htmlType="submit">Consultar</ButtonItem>
            </Space>
          }
        />

        {/* Cintillo de filtros */}
        <div style={{
          backgroundColor: "white", padding: 20, paddingTop: 5,
          borderRadius: 5, boxShadow: "0 4px 14px rgba(0,0,0,0.08)", marginBottom: 10,
        }}>
          <Tabs
            defaultActiveKey="1"
            style={{ margin: 0 }}
            tabBarExtraContent={{ left: <h1 style={{ padding: 0, margin: "0 10px 0 0" }}>Filtros:</h1> }}
          >
            <TabPane key="1" tab="Periodo">
              <FormItem name="periodo" noStyle>
                <RangePickerItem />
              </FormItem>
            </TabPane>
            <TabPane key="2" tab="Embudo">
              <FormItem name="embudoId" noStyle>
                <SelectItem
                  placeholder="Todos los embudos"
                  allowClear
                  style={{ width: "90%" }}
                >
                  {embudos.map((e) => (
                    <Option key={e._id} value={e._id}>{e.nombreEmbudo}</Option>
                  ))}
                </SelectItem>
              </FormItem>
            </TabPane>
          </Tabs>
        </div>

        <Spin spinning={loading}>
          <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
            {[
              { titulo: "Total Leads Activos", valor: totalLeads,  prefix: <TeamOutlined />,       color: "#1890ff", format: false },
              { titulo: "Valor en Pipeline",   valor: totalValor,  prefix: <DollarOutlined />,     color: "#52c41a", format: true  },
              { titulo: "Etapa con más Leads", valor: etapaTop,    prefix: <FunnelPlotOutlined />, color: "#722ed1", format: false, fontSize: 16 },
              { titulo: "Tasa de Avance",      valor: tasaAvance,  prefix: <RiseOutlined />,       color: "#fa8c16", format: false },
            ].map((k) => (
              <Col key={k.titulo} xs={12} sm={6} style={{ display: "flex" }}>
                <Card style={{ ...CARD_STYLE, flex: 1 }}>
                  <Statistic
                    title={k.titulo}
                    value={k.valor}
                    prefix={k.prefix}
                    formatter={k.format ? (v) => fmt(v) : undefined}
                    valueStyle={{ color: k.color, fontSize: k.fontSize }}
                  />
                  {k.titulo === "Tasa de Avance" && (
                    <div style={{ fontSize: 11, color: "#999", marginTop: 4 }}>Última etapa vs. primera</div>
                  )}
                </Card>
              </Col>
            ))}
          </Row>

          {datos.length === 0 && !loading ? (
            <Card style={CARD_STYLE}><Empty description="Sin leads activos en el pipeline" /></Card>
          ) : (
            <>
              <Card title="Distribución de Leads por Etapa" style={{ ...CARD_STYLE, marginBottom: 20 }}>
                <div style={{ height: Math.max(300, datos.length * 56) }}>
                  <ResponsiveBar
                    data={datos.map((d) => ({ etapa: d.nombre, Leads: d.cantidadLeads, color: d.color }))}
                    keys={["Leads"]} indexBy="etapa" layout="horizontal"
                    margin={{ top: 10, right: 80, bottom: 20, left: 160 }}
                    padding={0.25}
                    colors={(bar) => datos.find((d) => d.nombre === bar.indexValue)?.color ?? "#1890ff"}
                    colorBy="indexValue" borderRadius={4}
                    axisLeft={{ tickSize: 0, tickPadding: 10 }}
                    axisBottom={{ format: (v) => (Number.isInteger(v) ? v : "") }}
                    labelSkipWidth={30}
                    label={(d) => `${d.value} leads`}
                    tooltip={({ indexValue, value }) => {
                      const e = datos.find((d) => d.nombre === indexValue);
                      const pct = totalLeadsGlobal > 0 ? ((value / totalLeadsGlobal) * 100).toFixed(1) : 0;
                      return (
                        <div style={{ background: "white", padding: "8px 14px", border: "1px solid #f0f0f0", borderRadius: 6, fontSize: 13 }}>
                          <strong>{indexValue}</strong><br />
                          Leads: <strong>{value}</strong> ({pct}%)<br />
                          Valor: <strong>{fmt(e?.totalValor)}</strong>
                        </div>
                      );
                    }}
                    theme={{ fontSize: 12 }}
                  />
                </div>
              </Card>
              <Card title="Detalle por Etapa" style={CARD_STYLE}>
                <Table
                  dataSource={datos}
                  columns={columns}
                  rowKey={(r) => r.etapaId?.toString() ?? r.nombre}
                  size="small"
                  pagination={false}
                  summary={(pd) => {
                    const sl = pd.reduce((s, d) => s + d.cantidadLeads, 0);
                    const sv = pd.reduce((s, d) => s + d.totalValor, 0);
                    return (
                      <Table.Summary.Row>
                        <Table.Summary.Cell index={0} colSpan={2}><strong>Total</strong></Table.Summary.Cell>
                        <Table.Summary.Cell index={2} align="center"><strong>{sl}</strong></Table.Summary.Cell>
                        <Table.Summary.Cell index={3} align="right"><strong>{fmt(sv)}</strong></Table.Summary.Cell>
                        <Table.Summary.Cell index={4} align="right"><strong>100%</strong></Table.Summary.Cell>
                      </Table.Summary.Row>
                    );
                  }}
                />
              </Card>
            </>
          )}
        </Spin>
      </Form>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId:    state.empresa.id,
});

export default withRouter(connect(mapStateToProps)(ReporteEmbudo));
